import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Utils} from '../classes/utils';
import { WsService } from '../services/ws.service';
import { ADMINISTRATION_VOICES, ADMIN_VOICES, PRODUZIONE_VOICES, ROLES, VENDITORE_VOICES } from '../common/constants';
import { KeycloakService } from 'keycloak-angular';
import { mergeMap } from 'rxjs/operators';
import { noop } from 'rxjs';

@Component({
	selector: 'app-home',
	templateUrl: './home.component.html',
	styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

	public voices : string[] = [];
	public icons : string[] = [];
	public distribution = 100 / 5.40 + '%';
	public myRole: string;

	constructor(private router: Router,
				public utils : Utils,
				private wsService: WsService){

			this.voices = this.utils.myVoices;
			this.icons = this.utils.myIcons;
			this.goTo = this.goTo.bind(this);
	}

	ngOnInit(): void {
		this.myRole = this.utils.getHighestRole();

		if (this.myRole == "ADMIN") {
			this.wsService.adminVoices$.subscribe((updatedVoices: string[]) => {
				this.voices = updatedVoices;
			});
		} else if (this.myRole == "AMMINISTRAZIONE") {
			this.wsService.administratorVoices$.subscribe((updatedVoices: string[]) => {
				this.voices = updatedVoices;
			});
		} else if (this.myRole == "VENDITORE-EI" || this.myRole == "VENDITORE") {
			this.wsService.venditoreVoices$.subscribe((updatedVoices: string[]) => {
				this.voices = updatedVoices;
			});
		} else if (this.myRole == "PRODUZIONE") {
			this.wsService.produzioneVoices$.subscribe((updatedVoices: string[]) => {
				this.voices = updatedVoices;
			});
		}
        this.wsService.checkButtonsStatus()
        .subscribe(res => {
            let filteredVoices = this.wsService.getVoiceByRole(this.myRole);

            if (res.mode === 'OFF') {
                this.myRole = this.utils.getHighestRole();
                filteredVoices = this.wsService.getFilteredVoiceByRole(this.myRole);
            }

            this.updateVoice(filteredVoices);
        });
	}

    updateVoice(updatedVoices: string[]) {
        this.voices = updatedVoices;
        this.icons = this.voices.map(v => {
            const index = this.utils.myVoices.indexOf(v);
            return this.utils.myIcons[index];
        });
    }

	goTo(i: number): void {
		if(typeof i !== 'number') return;
		const path = this.retrievePath(this.voices[i]);
		this.router.navigateByUrl(path);
	}

	retrievePath(link: string): string {
		const lowerCase: string = link.toLowerCase();
		return '/dashboard/' + lowerCase;
	}

}




